import { render, staticRenderFns } from "./VideoDetailView.vue?vue&type=template&id=538d7ab8&"
import script from "./VideoDetailView.vue?vue&type=script&lang=js&"
export * from "./VideoDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports